import { Alert, Button } from "antd"
import { QboLinkingWarning } from "./invoiceSummaryModel"
import { CostCode } from "../../domain/costCodes/costCode"

type Props = {
  warnings: QboLinkingWarning[]
  costCodes: CostCode[]
  onLinkCustomerToQbo?: () => void
  onLinkCostCodeToQbo?: (costCodeId: number) => void
}

const QuickBooksLinkingWarnings = ({ warnings, costCodes, onLinkCustomerToQbo, onLinkCostCodeToQbo }: Props) => {
  if (warnings.length < 1) {
    return null
  }

  return <Alert
    type="warning"
    showIcon
    description={<>
      <span>The following must be linked to QuickBooks before you can create an invoice:</span>
      <ul>
        {warnings.map((warning, index) => {
          if (warning.type === 'customer') {
            return <li key={`${index}-customer`}>
              <Button type="link" onClick={onLinkCustomerToQbo}>Customer</Button>
            </li>
          }

          const costCode = costCodes.find(x => x.id === warning.costCodeId)
          return <li key={`${index}-${warning.costCodeId}`}>
            <Button type="link" onClick={() => onLinkCostCodeToQbo?.(warning.costCodeId)}>Cost Code: {costCode?.name}</Button>
          </li>
        })}
      </ul>
    </>}
  />
}

export default QuickBooksLinkingWarnings